import { render } from "./deleteItemIcon.vue?vue&type=template&id=be043fce&scoped=true"
const script = {}

import "./deleteItemIcon.vue?vue&type=style&index=0&id=be043fce&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be043fce"]])

export default __exports__